import React, { Component, cloneElement } from 'react'

const styles = {
  container: {
    position: 'relative',
    maxWidth: '100%',
    height: 0,
  },
  content: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
}

class AspectRatio extends Component {
  render() {
    const { children, aspectRatio, style, className, ...rest } = this.props
    const paddingBottom = `${ 100 / (aspectRatio !== undefined? aspectRatio : 1 )}%`

    let newChildren = children

    if (children !== undefined) {
      if (children.length) {
        newChildren = children.map((child, index) => {
          return cloneElement(child, {
            key: index,
            ...child.props,
            style: {
              ...child.props.style,
              ...styles.content,
            },
          })
        })
      } else {
        newChildren = cloneElement(children, {
          ...children.props,
          style: {
            ...children.props.style,
            ...styles.content,
          },
        })
      }
    }

    return (
      <div className={`${className} aspect-ratio`} style={{ ...styles.container, paddingBottom: paddingBottom, ...style }} {...rest}>
        <div className="aspect-ratio-container" style={styles.content}>
          {children}
        </div>
      </div>
    )

    return (
      <div style={{ ...styles.container, paddingBottom: paddingBottom, ...style }} {...rest}>
        {newChildren}
      </div>
    )
  }
}

export default AspectRatio



// WEBPACK FOOTER //
// ./src/components/AspectRatio/index.js